<template>
  <div class="next_bg">
		<!-- 头部 -->
		<div style="color: #fff;margin: 0 9vw;line-height: 8vh;font-size:0.9em;margin-top: 7px;">			
			<p style="float:left;"><span>{{now_index+1}}</span> / <span>{{info.total_number}}</span>&nbsp;&nbsp;&nbsp;</p>
      <p style="float:right;width: 30px;height: 30px;"@click="play"><!-- <i v-bind:class="[isplay ?  'fa-pause' : 'fa-play']" aria-hidden="true" class="fa"></i> -->
        <img src="../assets/images/play.png" width="100%" v-show="false">
      </p>
			<p style="float: right;margin-right: 20px;">倒计时:<van-count-down :time="time" @finish="finish" style="color:unset;float: right;line-height:8vh;" /></p>
      
		</div>	
		<!-- 题目 -->

  <van-form >
    <div v-if="list.length >0" v-for="(item, index) in list" v-show="index==now_index" class="next_con" >

      <p style="font-size: 1.1em;text-align: left;text-align:justify;line-height: 1.5em;margin: 0.8em 0.7em 0.6em;">
        <span style="line-height:8vh;color: #fff;background: #f6b36d;padding: 5px;border-radius: 5px;font-size: 0.8em;"><span v-if="item.type == 1">单选题</span><span v-if="item.type == 2">多选题</span><span v-if="item.type == 3">判断题</span></span>
        
        {{item.name}}
      </p>
	  
      <van-radio-group v-if="item.type == 1 || item.type == 3" v-model="radio_value" class="radio">
        <van-radio :name="val.id" v-for="(val, i) in item.answer" checked-color="#07c160" icon-size="1em" class="radio_txt">{{val.title}}</van-radio>
      </van-radio-group>
      <van-checkbox-group v-else-if="item.type == 2" v-model="checkbox_value">
        <van-checkbox :name="val.id" v-for="(val, i) in item.answer">{{val.title}}</van-checkbox>
      </van-checkbox-group>

    </div>
    <div style="margin: 16px;">
      <van-button v-if="now_index == list.length -1 " round block type="info" @click="changeQ" size="large" class="next_btn" color="#f6b36d">
        提交
      </van-button>
      <van-button type="primary" @click="changeQ" round block v-else size="large" class="next_btn" color="#f6b36d">下一题</van-button>

    </div>
  </van-form>
  <van-dialog v-model="show" title="" :before-close="buttonCallBack">
    <div class="">
      <div class="answer-content" v-if="user_true" >
        <van-icon name="checked" color="#07c160" /> 恭喜您答对了
      </div>
      <div class="answer-content" v-else >
        <van-icon name="clear" color="#ee0a24"  /> 对不起，您答错了 <br />
        <p v-html="true_answer"></p>
      </div>

    </div>
  </van-dialog>
  <!-- <audio :src="mus" class="media-audio" loop autoplay ref="MusicPlay" controls  id="audio_mp3" style="display: none;"></audio> -->
	
	
	<van-popup v-model="showuser" style=" min-width:320px;height: 60vh;width: 100%;padding: 8vh 0;" round position="bottom" :close-on-click-overlay="closeOnClickOverlay">
	    <van-form @submit="u_onSubmit" class="form">
	      <van-field
	        v-model="username"
	        name="name"
	        label="姓名"
	        placeholder="请输入姓名"
	        :rules="[{ required: true, message: '请输入姓名' }]"
	      />
	      <van-field
	        v-model="mobile"
	        type="number"
	        name="mobile"
	        label="手机号"
	        placeholder="请输入手机号"
	        :length="11"
	        :rules="[{ validator, message: '请输入正确手机号' }]"
	      />
	    
	      <div style="margin: 16px;">
	        <van-button round block type="info" native-type="submit" color="linear-gradient(to bottom, #2999ff, #0570DB)">
	          提交
	        </van-button>
	      </div>
	    </van-form>
	    
	  </van-popup>
	
	
</div>
</template>

<script>
import { datiStore, datiQestionInfo } from '@/api/user.js'
import { getResultUrl } from '@/utils/app.js'
import { getUserInfo,setUserInfo } from '@/api/user'
import { Toast } from 'vant'
//is_show_true_answer
export default {
  name: 'DatiView',
  components: {},
  data () {
    return {
      show: false,
      info: this.$store.state.acc,
      user: this.$store.state.user,
      luosimao_code: this.$store.state.luosimao_code,
      list: [],
      now_index: 0,//当前题目的索引
      radio_value: 0,
      checkbox_value: [],
      submit_title: '下一题',
      user_answer: [],//用户的所选项
      user_true: true,//用户每题答对答错情况
      true_answer: '',//当前用户正确答案，用于展示
      time: this.$store.state.acc.user_time * 1000,
	    type:1,
      mus: "http://oss.ahxmgk.com/audios/6/2019/09/ear4MwsNpMn4RAnrGRR4W9ea2Ag48J.mp3",  //使用的音频
  	  showuser:false,
  	  username:'',
  	  mobile:'',
  		closeOnClickOverlay:false,
      isplay:true,
      ismuted:false,
    }
  },
  watch:{
  	now_index : {
  		handler(n,o){    //n：当前的值，o：变化之前的值
  	        console.log(n,o)//根据数据变化，写业务逻辑
  			
  		},
      immediate: true,//设置是否一开始就对数据进行监听   也就是是否立即执行handler函数，false为不执行   
      deep:true//普通的watch方法无法监听到对象内部属性的改变，只有data中的数据才能够监听到变化，此时就需要
  	}
  },
  created() {
    
    this.init()
    
    document.addEventListener('DOMContentLoaded', function () {
        
        // audioAutoPlay();
    });
    //--创建触摸监听，当浏览器打开页面时，触摸屏幕触发事件，进行音频播放
    document.addEventListener('touchstart', function () {
       
        // audioAutoPlay();
    });

  },
  methods: {
    init() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: false,
        duration: 10000
      })
      datiQestionInfo({luosimao_code: this.luosimao_code}).then(res=>{
        this.$toast.clear()
        if(res.code && res.code ==201) {
          this.$dialog.alert({
            message: res.message,
          }).then(() => {
            this.$router.back()
          });
        }else{
          this.list = res
        }
        console.log(res)
        
      })
      
    },
    audioAutoPlay() {
      var musicEle0 = document.getElementById('audio_mp3');
                musicEle0.play();
    },
    audioPause() {
      var musicEle0 = document.getElementById('audio_mp3');
                musicEle0.pause();
    },
    play(){
      this.isplay = !this.isplay
      this.ismuted = !this.ismuted
      if(this.ismuted){
        this.audioPause()

      }else{
        
        this.audioAutoPlay()

      }
      


    },
    changeQ() {
      if(this.list[this.now_index]['type'] == 3 || this.list[this.now_index]['type'] == 1) {
        this.user_answer.push(this.radio_value)
      }else{
        this.user_answer.push(this.checkbox_value)
      }
      //如果显示正确答案
      if(this.info.is_show_true_answer == 1) {
        this.getTrueAnswer()
		    this.show = true
      }else{
        this.getTrueAnswer()
		// this.show = true
      if(this.now_index == this.info.total_number - 1) {//最后一题直接提交
        this.onSubmit()
				//this.userinfo()
      }else{
        this.now_index ++
      }
      this.radio_value = 0
      this.checkbox_value = []

      }
    },
    onSubmit(){
      this.$toast.loading({
        message: '加载中...',
        forbidClick: false,
        duration: 10000
      })
      let _this = this
      datiStore({user_answer: this.user_answer}).then(res=>{
        this.$toast.clear()
        this.$toast.success({
          message: '提交成功'
        })
        this.$store.commit('SET_ANSWER_RESULT', res)
        setTimeout(function(){
          _this.$router.push({name: 'DatiResult', params: {id: res.id}})
        }, 2000);

      })
      // return false
      
    },
    //获取当前题目的正确答案，用于展示
    getTrueAnswer() {
      // if(this.info.is_show_true_answer == 0) return ''
      let true_answer = []
      let true_answer_string = '正确答案为：<br />'
      let q = this.list[this.now_index]
      let i = 0
      for (let ii in q['answer']) {
        if(q['answer'][ii]['is_true'] == 1) {
          true_answer[i] = q['answer'][ii]['id']
          true_answer_string += '<li>'+ q['answer'][ii]['title']+'</li>'
          i ++
        }
      }
      this.true_answer = true_answer_string
      console.log(true_answer)
      console.log(this.checkbox_value.length)
      console.log(this.checkbox_value)
      //判断用户答对答错
      if(q.type == 1 || q.type == 3) {
        if(true_answer.length == 1 && this.radio_value == true_answer[0]) {
          this.user_true = true
        }else{
          this.user_true = false
        }
      }else if(q.type == 2) {//多选
        if(true_answer.length == this.checkbox_value.length) {
          let a = 0
          for (var aa in this.checkbox_value) {
            if(true_answer.indexOf(this.checkbox_value[aa]) >= 0) {
              a ++
            }
          }
          if(a == true_answer.length) {
            this.user_true = true
          }else{
						this.user_true = false
					}
        }else{
          this.user_true = false
        }
      }  
	  
      // this.show = true
      
    },
    buttonCallBack(action, done) {
      console.log(this.now_index)
      if(this.now_index == this.info.total_number - 1) {//最后一题直接提交
        this.onSubmit()
        // this.userinfo()
      }else{
        this.now_index ++
      }
      this.radio_value = 0
      this.checkbox_value = []
      done()
    },
    finish() {//倒计时结束，直接提交
      this.onSubmit()
        //this.userinfo()
    },
    userinfo(){
      this.showuser = true
    },
    u_onSubmit(values){
      Toast('加载中');

      setUserInfo(values).then(res=>{
            // setToken(res.access_token)
            this.$store.commit('SET_USER', res.user)
            getUserInfo().then(res=>{
            this.$store.commit('SET_USER', res)
            Toast.clear()
             this.onSubmit()
            })
          })
    },
    validator(val) {
      return /^1(3|4|5|6|7|8|9)\d{9}$/.test(val);
    },
   
  }
}
</script>
<style>
.van-radio__label{
  line-height: 1.5em;
  margin-right: 10px;

  }
.answer-content {text-align:center; line-height:30px; margin: 30px auto;}
.answer-content p { margin: 10px;text-align:left;}
.next_bg{
  background: url(../assets/images/bg.jpg) no-repeat center;
  background-size: cover;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  font-size: 1.05em;
}
.next_con{
  background: rgba(255,255,255,0.8);  
  position: fixed;
  top:8vh;
  left: 7vw;
  width: 86vw;
  height: 88vh;
  border-radius: 5px;
  overflow: scroll;
}
.radio{
  padding-left: 1em;
  font-size: 1.0em;
  margin: 0.1em 0;
}
.radio_txt{
  margin: 0.5em 0;
  line-height: 1.5em!important;
}
.van-checkbox{
  margin: 0.5em 0;
  line-height: 1.5em!important;
}
.next_btn{
  position: fixed;
  top: 82vh;
  left: 15vw;
  width: 70vw;
  height: 7vh;
  line-height: 7vh;
  font-size: 5vw;
}
.next_tips{
  padding: 0.8em 1.0em 0.6em;
  border-radius: 8px;
}
.info_tips{
  padding: 0.8em 0 0.6em;
  border-radius: 8px;
  width: 70vw;
}
/* 载入动画效果 */
/* .fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
} */
.fade-enter-active, .fade-leave-active {
  transition: all .2s ease;
}
.fade-enter,.fade-leave-active {
  opacity: 0;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.next_bg .van-radio__label{
	font-size: 1.1em;
}
.next_bg .van-checkbox__label{
	font-size: 1.1em;
}
.van-checkbox-group{
	overflow-y: auto;
	    height: 16em;
	    margin-top: -0.6em;
	    width: 94%;
	    margin-left: 2%;
	    padding-bottom: 8em;
}

</style>
